const Truncate = (str:string, num:number):string =>{


    let truncated = "";
    let noSpaces = str.replace(/\s*/g, '')

    if (str === null){
        return;
    }

    if (num < noSpaces.length){

        if (str.charAt(num -1) === ' '){
            truncated = str.slice(0,num -1) + "...";
        }

        truncated = str.slice(0,num) + "...";

        // Handle captials
        const noDots = str.slice(0,num);
        const count = noDots.length - noDots.replace(/[A-Z]/g, '').length;
        const percent = count / noDots.length * 100;

        if (percent > 25 && noDots.length > 8){

            if(truncated.includes("#PD (V")){
                debugger;
            }
            truncated = str.slice(0, (num -4)) + "...";
        }

    } 
    else { 
        truncated = str
    }

    return truncated;
}  

const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}

export const SimpleTruncate = (str: string, num: number): string => {
    if (!str || num <= 0) return "";

    return str.length > num ? str.slice(0, num) + "..." : str;
};

export const makePlural = (countValue: number, noun:string) => countValue === 1 ? noun : `${noun}s`

export const leadingZero = (number: number | string) => Number(number) <= 9 ? `0${number}` : number
  
export const capitaliseFirstLetter = (str: string): string => {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const removeSpaces = (input: string | number): string => {
    return String(input).replace(/\s+/g, '');
};
  

export { Truncate , uuidv4 };